export default __webpack_public_path__ + "static/media/boat.26ae6d36.png";